export const maintenanceListStructure = {
  Supplier: '廠商',
  Name: '維養計畫名稱',
  Between: '計畫起訖日',
  Categories: '設備類別',
  Cost: '費用預算',
  Status: '計畫狀態'
}

export const maintenanceYearList = [
  { value: 5, label: '5 年' },
  { value: 10, label: '10 年' },
  { value: 20, label: '20 年' },
  { value: 30, label: '30 年' },
  { value: 40, label: '40 年' },
  { value: 50, label: '50 年' }
]

export const changeBudgetStructure = {
  Category: '設備類別',
  AssetName: '設備名稱',
  Cost: '購置金額',
  LifeInYear: '耐用年限',
  ExpectedReplacementCount: '預期更換次數',
  TotalCost: '預期更換費用'
}

export const maintenanceBudget = {
  PlanName: '計劃名稱',
  Categories: '設備類別',
  CostPerYear: '年維養費用',
  TotalCost: '總維養費用'
}

export const maintenanceProjectStructure = {
  Title: '維養計畫名稱',
  Supplier: '設備廠商',
  Budget: '費用預算',
  Between: '計畫起訖日'
}

export const maintenanceProjectItemStructure = [
  {
    key: 'CategoryName',
    label: '設備類別',
    isRequire: true
  },
  {
    key: 'AssetName',
    label: '設備項目',
    isRequire: true
  },
  {
    key: 'PeriodType',
    label: '週期',
    isRequire: true
  },
  {
    key: 'PeriodValue',
    label: '頻次',
    isRequire: true
  },
  {
    key: 'ShouldBeChecked',
    label: '應檢次數',
    isRequire: 0
  },
  {
    key: 'HasBeenChecked',
    label: '已檢次數',
    isRequire: 0
  }
]

export const periodTypeOptions = [
  {
    label: '年',
    value: 'year'
  },
  {
    label: '季',
    value: 'quarter'
  },
  {
    label: '月',
    value: 'month'
  },
  {
    label: '週',
    value: 'week'
  }
]
export const maintenanceProjectItemAddStructure = [
  {
    key: 'CategoryName',
    label: '設備類別',
    isRequire: true,
    type: 'cascader',
    options: []
  },
  {
    key: 'AssetId',
    label: '設備項目',
    isRequire: true,
    type: 'select',
    options: []
  },
  {
    key: 'PeriodType',
    label: '週期',
    isRequire: true,
    type: 'select',
    options: periodTypeOptions
  },
  {
    key: 'PeriodValue',
    label: '頻次',
    isRequire: true,
    maxLength: 2,
    isNum: true
  },
  {
    key: 'MaintenanceContent',
    label: '維養內容',
    isFull: true,
    isTextArea: true,
    maxLength: 300
  },
  {
    key: 'CheckContent',
    label: '檢查項目',
    isFull: true,
    isTextArea: true,
    maxLength: 300
  },
  {
    key: 'Note',
    label: '備註',
    isFull: true,
    isTextArea: true,
    maxLength: 300
  }
]

export const maintenanceProjectRecordStructure = [
  {
    key: 'NextTime',
    label: '預期保養日期'
  },
  {
    key: 'EquipmentCategory',
    label: '設備類別'
  },
  {
    key: 'EquipmentName',
    label: '設備名稱'
  },
  {
    key: 'ReportTime',
    label: '廠商回報日期'
  },
  {
    key: 'State',
    label: '狀態'
  },
  {
    key: 'StaffName',
    label: '回報人'
  },
  {
    key: 'PhoneNumber',
    label: '電話'
  }
  // 此階段無備註
  // {
  //   key: "note",
  //   label: "回覆備註"
  // }
]
